import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { IAppState } from './core/store/state';
import { selectIsLogged } from './core/store/selectors';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  isLogged$ = this.store.select(selectIsLogged);

  constructor(private store: Store<IAppState>) {}
}
